import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const QuoteSection: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section ref={ref} className="container mx-auto px-6 lg:px-12 py-24">
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-3xl mx-auto text-center"
        >
          <p className="font-heading text-2xl sm:text-3xl text-primary italic leading-relaxed">
            "Não deixe que a burocracia seja a âncora que te impede de zarpar."
          </p>
          <footer className="mt-6 text-sm text-muted-foreground">
            — Equipe JL Despachante
          </footer>
        </motion.blockquote>
    </section>
  );
};

export default QuoteSection;
